import React, { useRef, useState } from 'react'
import Tooltip from '../../../Tooltip/Tooltip'
import { useDispatch, useSelector } from 'react-redux'
import { hideTrackedLinkCreateModal, showAnalyticsModal } from '../../../../actions'
import analyticsTypes from '../../../../enums/analytics/analyticsTypes'
import './TrackedLinksTableRecord.css'
import { Col, Row } from 'react-bootstrap'

const TrackedLinksTableRecord = ({ link, onDelete }) => {
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const dispatch = useDispatch()
  const site = useSelector((state) => state.modals.trackedModalPayload.site)

  const [tooltipState, setTooltipState] = useState({
    active: false,
    target: null,
    text: 'Copied!'
  })

  const copyIconRefs = useRef({})

  const setCopyRef = (element, linkLabel) => {
    copyIconRefs.current[linkLabel] = element
  }

  const handleDeleteClick = () => {
    if (isDeleteMode) {
      onDelete(link.label)
      setIsDeleteMode(false)
    } else {
      setIsDeleteMode(true)
    }
  }

  const handleCancelDelete = () => {
    setIsDeleteMode(false)
  }

  const handleCopyLink = (url, linkLabel) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        const targetElement = copyIconRefs.current[linkLabel]
        if (targetElement) {
          setTooltipState({
            active: true,
            target: targetElement,
            text: 'Copied!'
          })
        }
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
        const targetElement = copyIconRefs.current[linkLabel]
        if (targetElement) {
          setTooltipState({
            active: true,
            target: targetElement,
            text: 'Error!'
          })
        }
      })
  }

  const handleTooltipHide = () => {
    setTooltipState({ active: false, target: null, text: 'Copied!' })
  }

  const navigateToTrackedAnalytics = () => {
    dispatch(
      showAnalyticsModal({
        analyticsType: analyticsTypes.TRACKED,
        site
      })
    )
    dispatch(hideTrackedLinkCreateModal())
  }

  return (
    <Row key={link.label} className={`tracked-link-record align-items-center m-0 border-bottom`}>
      <Col xs={6} md={2} className="mb-2 mb-md-0 fw-medium text-truncate order-0 order-md-0">
        <span
          className="tracked-link-label"
          onClick={() => navigateToTrackedAnalytics()}
          title="View tracked link analytics"
        >
          {link.label}
        </span>
      </Col>
      <Col xs={12} md={8} lg={9} className="mb-2 mb-md-0 fw-medium order-2 order-md-1 text-center">
        <span className="tracked-link-url">{link.url}</span>
      </Col>
      <Col xs={6} md={2} lg={1} className="mb-2 mb-md-0 fw-medium order-1 order-md-2">
        <div className="tracked-link-actions justify-content-end">
          <img
            ref={(el) => setCopyRef(el, link.label)}
            src="/assets/icons/export/copy.svg"
            alt="Copy Link"
            height="18"
            width="18"
            className="tracked-link-icon copy"
            onClick={() => handleCopyLink(link.url, link.label)}
          />
          <img
            src="/assets/icons/export/cancel.svg"
            alt="Cancel Delete"
            height="17"
            width="18"
            className={`tracked-link-icon cancel ${isDeleteMode ? 'visible' : ''}`}
            onClick={handleCancelDelete}
          />
          <img
            src="/assets/icons/export/delete.svg"
            alt={isDeleteMode ? 'Confirm Delete' : 'Delete Link'}
            height="18"
            width="18"
            className={`tracked-link-icon delete ${isDeleteMode ? 'confirm' : ''}`}
            onClick={handleDeleteClick}
          />
        </div>
      </Col>
      <Tooltip
        active={tooltipState.active}
        target={tooltipState.target}
        text={tooltipState.text}
        placement="top"
        onHide={handleTooltipHide}
        time={1500}
      />
    </Row>
  )
}

export default TrackedLinksTableRecord
